import { render, staticRenderFns } from "./importquotas.vue?vue&type=template&id=32909281&"
import script from "./importquotas.vue?vue&type=script&lang=js&"
export * from "./importquotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports